<template>
  <div>
    <!-- Section de sélection de la fonction -->
    <b-card title="Fonction">
      <validation-observer ref="observer">
        <b-row>
          <!-- Champ pour la fonction -->
          <b-col md="6" class="mb-1">
            <b-form-group label="Fonction" label-for="fonctionInput">
              <validation-provider
                #default="{ errors }"
                name="Fonction"
                rules="required"
              >
                <b-form-input
                  v-model="user.fonction"
                  :state="errors.length > 0 ? false : null"
                  @input="emitUserFonctionUpdate"
                  placeholder="Fonction"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Sélection de la direction -->
          <b-col md="6" class="mb-1">
            <b-form-group label="Direction">
              <validation-provider
                #default="{ errors }"
                name="Direction / Cellule"
                rules="required"
              >
                <v-select
                  v-model="user.directions.id"
                  :state="errors.length > 0 ? false : null"
                  @input="emitUserFonctionUpdate"
                  label="name"
                  :options="directionsAll"
                  :reduce="direction => direction.id"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Sélection du service -->
          <b-col v-if="showServices" md="6" class="mb-1">
            <b-form-group label="Service">
              <!-- <validation-provider
                #default="{ errors }"
                name="Service"
                rules="required"
              > -->
              <!-- :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" -->

                <v-select
                  v-model="user.services.id"
                  @input="emitUserFonctionUpdate"
                  label="name"
                  :options="servicesAll"
                  :reduce="service => service.id"
                />
                <!-- <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider> -->
                                <!-- :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" -->

            </b-form-group>
          </b-col>
          <!-- Sélection du péage -->
          <b-col v-if="showPeages" md="6" class="mb-1">
            <b-form-group label="Péage">
              <!-- <validation-provider
                #default="{ errors }"
                name="Péage"
                rules="required"
              > -->
                <v-select
                  v-model="user.toll.id"
                  @input="emitUserFonctionUpdate"
                  label="name"
                  :options="peagesAll"
                  :reduce="toll => toll.id"
                />
                <!-- <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider> -->
                                <!-- :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" -->

            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
//import BCardCode from '@core/components/b-card-code'
import { BFormInput, BRow, BCol, BFormGroup,BCard } from 'bootstrap-vue'
import { allServicesByDirections, } from '@/services/ServicesService'
import { allDirections,getAllDirectionsByActive } from '@/services/DirectionsService'
import { allPeages ,allPeagesActive} from '@/services/TollService'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    vSelect,
    BCard,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      user: {
        fonction: '',
        directions: { id: null },
        services: { id: null },
        toll: { id: null },
      },
      directionsAll: [],
      servicesAll: [],
      peagesAll: [],
      showServices: false,
      showPeages: false,
      active:true,
    }
  },
  watch: {
    'user.directions.id': 'fetchServicesAndPeages',
    'user.services.id': 'updateShowPeages',
  },
  methods: {
    async fetchServicesAndPeages(directionId) {
      if (!directionId) {
        this.servicesAll = []
        this.peagesAll = []
        this.showServices = false
        this.showPeages = false
        return
      }
      try {
        this.servicesAll = await allServicesByDirections(directionId,this.active)
       
        this.showServices = this.servicesAll.length > 0
        this.updateShowPeages()
      } catch (error) {
        console.error('Error fetching services:', error)
      }
    },
    async updateShowPeages() {
      const selectedService = this.servicesAll.find(service => service.id === this.user.services.id)
      const selectedServiceHasToll = selectedService && selectedService.toll

      if (selectedServiceHasToll) {
        try {
          this.peagesAll = await allPeagesActive(this.active)
          this.showPeages = true
        } catch (error) {
          console.error('Error fetching peages:', error)
        }
      } else {
        this.showPeages = false
      }
    },
    emitUserFonctionUpdate() {
      this.$emit('update-fonction', this.user)
    },
    validateForm() {
      return this.$refs.observer.validate();
    },
    updateForm(data) {
      // Synchroniser les données reçues avec l'objet local
      this.user = { ...this.user, ...data };
    },
    reset() {
      this.user = {
        fonction: '',
        directions: { id: null },
        services: { id: null },
        toll: { id: null },
      };
    },
  },
  async created() {
    try {
      const directionsData = await getAllDirectionsByActive(this.active)
      this.directionsAll = directionsData
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  },
 
}
</script>

<style lang="scss" scoped>
.mb-1 {
  margin-bottom: 1rem;
}
@import '@core/scss/vue/libs/vue-select.scss';
</style>
